import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import { getComponentDefinition, getComponentLabel, getTrackingFactLabel } from '../../helper'
import Checkbox from '../../../Form/Checkbox'
import './styles.scss'
import activityTrackingService from '../../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../../constants'
import { FACT_LABEL_HOVER_COLOR, FACT_LABEL_TOOLTIP_DELAY, FACT_LABEL_TOOLTIP_MIN_WIDTH } from '../../constants'

class AttributeCheckbox extends PureComponent {

  onChange = (e) => {
    activityTrackingService.trackEvent(trackingEvent.editAttribute, {
      name: getTrackingFactLabel(this.props.parentBlueprint, this.props.factsheetBlueprint)
    })
    if (e.target.checked) {
      this.props.putAttribute(
        this.props.parentBlueprint.id,
        this.props.factInstanceKey,
        this.props.blueprint.id,
        {
          attributeDefId: this.props.blueprint.id
        })
      return
    }
    this.props.deleteAttribute(
      this.props.parentBlueprint.id,
      this.props.factInstanceKey,
      this.props.blueprint.id
    )
  }

  render () {
    const attributeDefId = this.props.blueprint.id
    const attribute = this.props.factsheetBlueprint.factTree.attributes[attributeDefId]
    const label = getComponentLabel(
      this.props.blueprint,
      attribute)
    const checked = typeof this.props.data !== 'undefined'
    if (this.props.collapsed) {
      if (!checked) {
        return null
      }
      return <div className={'attribute-checkbox-collapsed'}>{label}</div>
    }
    const definition = getComponentDefinition(
      this.props.blueprint,
      attribute)
    return (
      <div className={'attribute-checkbox'}>
        <Checkbox
          value={checked}
          onChange={this.onChange}
          label={label}
          labelHoverColor={FACT_LABEL_HOVER_COLOR}
          tooltip={definition}
          tooltipHoverDelay={FACT_LABEL_TOOLTIP_DELAY}
          tooltipMinWidth={FACT_LABEL_TOOLTIP_MIN_WIDTH}
          kind={'secondary'}
        />
      </div>
    )
  }
}

AttributeCheckbox.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number.isRequired,
  putAttribute: PropTypes.func.isRequired,
  deleteAttribute: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired,
  data: PropTypes.object,
}
export default AttributeCheckbox
